import TreeComponent from "../TreeComponent";
import {
  nameFilter,
  inullFilter,
  activeFilter
} from "../../../../services/FilteringUtils";

class SearchableTreeComponent extends TreeComponent {
  constructor(props) {
    super(props);

    this.state = this.initialState();
  }

  initialState() {
    return {
      ...super.initialState(),
      searchValue: ""
    };
  }

  initialPageInfo() {
    return {
      ...super.initialPageInfo(),
      filters: {
        ...activeFilter,
        ...this.getSearchFilter(),
        modelParentId: inullFilter
      }
    };
  }

  getSearchFilter() {
    return nameFilter;
  }

  onSearchChange = e => {
    const searchValue = e.target.value;
    this.state.searchValue = searchValue;
    this.state.pageInfo.number = 0;
    let pageInfo = this.state.pageInfo;
    pageInfo = this.createSearchInfo(searchValue, pageInfo);
    this.startLoading(pageInfo);
  };

  renderProps() {
    return {
      ...super.renderProps(),
      onSearchChange: this.onSearchChange,
      searchValue: this.state.searchValue
    };
  }
}

export default SearchableTreeComponent;
